import * as React from "react";
import { useCallback, useMemo } from "react";
import styled from "styled-components";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import AggregationWidgetConfig from "views/logic/aggregationbuilder/AggregationWidgetConfig";
import Pivot, { DateType } from "views/logic/aggregationbuilder/Pivot";
import Series from "views/logic/aggregationbuilder/Series";
import InteractiveContext from "views/components/contexts/InteractiveContext";
import FullSizeContainer from "views/components/aggregationbuilder/FullSizeContainer";
import XYPlot from "views/components/visualizations/XYPlot";
const config = AggregationWidgetConfig.builder().visualization("bar").rowPivots([Pivot.create(["category"], DateType)]).series([Series.forFunction("count()")]).rollup(false).build();
const height = 180;
const GraphContainer = styled.div`
  height: ${height}px;
  width: 100%;
  margin: 20px 0;
`;
const defaultLayout = (type) => ({
  type: "bar",
  name: type,
  textposition: "auto",
  originalName: type,
  marker: {
    color: "#4478b3"
  },
  outsidetextfont: {
    color: "#F6F7FC"
  },
  showlegend: false,
  xaxis: {
    tickangle: -45
  },
  yaxis: "y",
  fullPath: `${type}\u2E31count()`
});
export const otherBucket = ["Other", "Other"];
const Histogram = ({ x, y, text, type, onClickMarker }) => {
  const store = useMemo(
    () => configureStore({
      reducer: (state) => state,
      preloadedState: { view: { activeQuery: "deadbeef" } }
    }),
    []
  );
  const onZoom = useCallback(() => true, []);
  const chartData = useMemo(
    () => [
      {
        ...defaultLayout(type),
        x,
        y,
        text
      }
    ],
    [type, x, y, text]
  );
  return /* @__PURE__ */ React.createElement(Provider, { store }, /* @__PURE__ */ React.createElement(GraphContainer, null, /* @__PURE__ */ React.createElement(InteractiveContext.Provider, { value: true }, /* @__PURE__ */ React.createElement(FullSizeContainer, null, (dimensions) => /* @__PURE__ */ React.createElement(
    XYPlot,
    {
      config,
      chartData,
      onZoom,
      height,
      width: dimensions.width,
      onClickMarker
    }
  )))));
};
export default Histogram;
